<template>
  <FormRegistrator @reload="reloadForm" :key="`form-registrator=${key}`"/>
</template>

<script>
import FormRegistrator from '@/views/form/FormRegistrator'

export default {
  name: 'FormRegistratorContainer',
  components: {FormRegistrator},
  comments: {
    FormRegistrator
  },
  data() {
    return {
      key: 0
    }
  },
  methods: {
    reloadForm() {
      this.key++
    }
  }
}
</script>
